import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import projects from "../projects";

const Projects = ({ darkMode }) => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  const updateScreenSize = () => {
    setIsSmallScreen(window.innerWidth <= 768);
  };

  // Add event listener for window resize
  useEffect(() => {
    window.addEventListener("resize", updateScreenSize);
    return () => window.removeEventListener("resize", updateScreenSize);
  }, []);

  const handleShowMore = (project) => {
    setSelectedProject(project);
  };

  const closeModal = () => {
    setSelectedProject(null);
  };

  return (
    <section
      id="projects"
      className={`my-5 ${
        darkMode ? "bg-dark text-white" : "bg-light text-dark"
      }`}
      style={{
        padding: "0",
      }}
    >
      <h2 className="text-center py-4">Mijn projecten</h2>
      <div
        id="projectCarousel"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="10000"
        style={{
          margin: "0 auto",
          maxWidth: "100%",
          backgroundColor: darkMode ? "#222" : "#f8f9fa",
          borderRadius: "10px",
          overflow: "hidden",
        }}
      >
        <div className="carousel-inner">
          {projects.map((project, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
              onClick={() => handleShowMore(project)}
              style={{
                cursor: "pointer",
                backgroundColor: darkMode ? "#333" : "#f8f9fa",
                color: darkMode ? "#fff" : "#000",
              }}
            >
              <div
                className="row align-items-center m-0"
                style={{ minHeight: "350px" }}
              >
                {/* Text Content */}
                <div
                  className="col-md-6 col-12 p-4"
                  style={{ textAlign: isSmallScreen ? "center" : "left" }}
                >
                  <h4>{project.title}</h4>
                  <p>
                    <strong>{project.year}</strong>
                  </p>
                  {project.subtitle && <h5>{project.subtitle}</h5>}
                  <p>
                    {isSmallScreen
                      ? `${project.description.slice(0, 150)}...`
                      : project.description}
                  </p>
                </div>

                {/* Image - Hide on smaller screens */}
                {!isSmallScreen && (
                  <div
                    className="col-md-6 col-12 p-0 d-flex justify-content-center"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <img
                      src={project.image}
                      alt={project.title}
                      className="img-fluid rounded"
                      style={{
                        maxWidth: "90%",
                        maxHeight: "300px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        <button
          className="carousel-control-prev custom-arrow-btn"
          type="button"
          data-bs-target="#projectCarousel"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon custom-arrow"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Vorige</span>
        </button>
        <button
          className="carousel-control-next custom-arrow-btn"
          type="button"
          data-bs-target="#projectCarousel"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon custom-arrow"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Volgende</span>
        </button>
      </div>

      {/* Modal */}
      {selectedProject && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          role="dialog"
          onClick={closeModal}
        >
          <div
            className="modal-dialog modal-lg"
            role="document"
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className={`modal-content ${
                darkMode ? "bg-dark text-light" : "bg-light text-dark"
              }`}
            >
              <div className="modal-header">
                <h5 className="modal-title">{selectedProject.title}</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  <strong>{selectedProject.year}</strong>
                </p>
                {selectedProject.subtitle && (
                  <h3
                    style={{
                      color: darkMode ? "#fff" : "#000",
                      fontWeight: "bold",
                    }}
                  >
                    {selectedProject.subtitle}
                  </h3>
                )}
                <p>{selectedProject.description}</p>
                <img
                  src={selectedProject.image}
                  alt={selectedProject.title}
                  className="img-fluid rounded shadow-sm"
                  style={{
                    width: "50%",
                    height: "50%",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
                {selectedProject.extraContentHTML && (
                  <div className="mt-4">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: selectedProject.extraContentHTML.replace(
                          /\n/g,
                          "<br>"
                        ),
                      }}
                      style={{
                        color: darkMode ? "#fff" : "#000",
                      }}
                    ></div>
                  </div>
                )}
                {selectedProject.extraContentJSX && (
                  <div className="mt-4">{selectedProject.extraContentJSX}</div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Projects;
